import { useContext } from "react";
import Button from "./Button";
import InputSearch from "./InputSearch";
import Select from "react-dropdown-select";
import { DashContext } from "../../../context/Dashboard/DashContext";

const InputSearchAndButtonAccess = ({
  widthInput,
  heightInput,
  nameButton,
  colorButtom,
  value,
  onChange,
  setModalFormAdmin,
  setOptionModalFormAdmin,
  setModalEdit,
  setFilter,
  options,
}) => {
  const { onGetFilterClient, setFilterName, filterName } =
    useContext(DashContext);

  const container = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const handleClick = () => {
    if (nameButton == "Novo usuário") {
      setOptionModalFormAdmin("create");
      setModalFormAdmin(true);
    } else if (nameButton === "Novo aceso BI") {
      setModalEdit(true);
    }
  };

  return (
    <div className="containerBox" style={container}>
      <div style={{ display: "flex" }}>
        <InputSearch
          width={widthInput}
          height={heightInput}
          value={filterName}
          onChange={setFilterName}
          onBlue={onGetFilterClient}
          onEnter={onGetFilterClient}
        />
        {options && (
          <Select
            style={{
              marginLeft: "45px",
              height: "45px",
              paddingLeft: "20px",
              paddingRight: "15px",
              border: "1px solid #d7d7d7",
              width: "200px",
              borderRadius: "60px",
              backgroundColor: "#fff",
            }}
            color="#000"
            placeholder="Selecione"
            dropdownHeight={"150px"}
            searchable={true}
            options={options}
            labelField="business"
            valueField="business"
            isSearchable={true}
            clearable={true}
            noDataLabel="Nenhuma empresa"
            onChange={(value) => {
              if (value.length === 0) {
                setFilter("");
              } else {
                setFilter(value);
              }
            }}
          />
        )}
      </div>
      <Button
        width="195px"
        height="45px"
        background={colorButtom}
        borderRadius="60px"
        marginTop="0"
        name={nameButton}
        color={"var(--white)"}
        onClick={handleClick}
        selectBtn={nameButton}
        border="none"
      />
    </div>
  );
};

export default InputSearchAndButtonAccess;
